<div class="service-provider-create-wrapper">
  <!-- HEADER -->

  @if (!isLoaded()) {
    <div class="loading">
      <nz-spin nzSimple nzSize="large" nzTip="Ładowanie danych podmiotu..." />
    </div>
  } @else {
    <div class="page-header">
      <div class="page-header-icon">
        <span nz-icon nzType="edit" nzTheme="outline"></span>
      </div>

      <div>
        <h2 class="page-header-title">Edycja podmiotu</h2>

        <p class="page-header-subtitle">Zmień dane podmiotu świadczącego usługi medyczne</p>
      </div>
    </div>
    <form nz-form nzLayout="vertical" class="create-form">
      <!-- PODSTAWOWE -->
      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="bank" nzTheme="outline" class="section-icon"> </span>

          <span> Dane podstawowe </span>
        </div>

        <div nz-row [nzGutter]="[24, 0]">
          <div nz-col [nzXs]="24" [nzSm]="16">
            <nz-form-item>
              <nz-form-label nzRequired> Nazwa podmiotu </nz-form-label>

              <nz-form-control
                [nzValidateStatus]="
                  serviceProviderForm.name().invalid() &&
                  (serviceProviderForm.name().touched() ||
                    submitted() ||
                    serviceProviderForm.name().dirty())
                    ? 'error'
                    : ''
                "
              >
                <input
                  nz-input
                  placeholder="np. Centrum Medyczne XYZ"
                  [formField]="serviceProviderForm.name"
                  [nzStatus]="serviceProviderForm.name().invalid() ? 'error' : ''"
                />
                <app-field-error
                  [control]="serviceProviderForm.name()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="8">
            <nz-form-item>
              <nz-form-label> Typ podmiotu </nz-form-label>

              <nz-form-control
                [nzValidateStatus]="
                  serviceProviderForm.type().invalid() &&
                  (serviceProviderForm.type().touched() ||
                    submitted() ||
                    serviceProviderForm.type().dirty())
                    ? 'error'
                    : ''
                "
              >
                <nz-select nzPlaceHolder="Wybierz typ" [formField]="serviceProviderForm.type">
                  @for (item of serviceProviderTypes; track item.name) {
                    <nz-option [nzValue]="item.name" [nzLabel]="item.description"> </nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24">
            <nz-form-item>
              <nz-form-label> Opis </nz-form-label>

              <nz-form-control
                [nzValidateStatus]="
                  serviceProviderForm.description().invalid() &&
                  (serviceProviderForm.description().touched() ||
                    submitted() ||
                    serviceProviderForm.description().dirty())
                    ? 'error'
                    : ''
                "
              >
                <textarea
                  nz-input
                  rows="3"
                  placeholder="Opis działalności podmiotu"
                  [formField]="serviceProviderForm.description"
                  [nzStatus]="serviceProviderForm.description().invalid() ? 'error' : ''"
                >
                </textarea>
                <app-field-error
                  [control]="serviceProviderForm.description()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </nz-card>

      <!-- REJESTRY -->
      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="idcard" nzTheme="outline" class="section-icon"> </span>

          <span> Dane rejestrowe </span>
        </div>

        <div nz-row [nzGutter]="[24, 0]">
          <div nz-col [nzXs]="24" [nzSm]="6">
            <nz-form-item>
              <nz-form-label> NIP </nz-form-label>

              <nz-form-control
                [nzValidateStatus]="
                  serviceProviderForm.taxId().invalid() &&
                  (serviceProviderForm.taxId().touched() ||
                    submitted() ||
                    serviceProviderForm.taxId().dirty())
                    ? 'error'
                    : ''
                "
              >
                <input
                  nz-input
                  placeholder="Numer NIP"
                  [formField]="serviceProviderForm.taxId"
                  [nzStatus]="serviceProviderForm.taxId().invalid() ? 'error' : ''"
                />
                <app-field-error
                  [control]="serviceProviderForm.taxId()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="6">
            <nz-form-item>
              <nz-form-label> REGON </nz-form-label>

              <nz-form-control
                [nzValidateStatus]="
                  serviceProviderForm.regon().invalid() &&
                  (serviceProviderForm.regon().touched() ||
                    submitted() ||
                    serviceProviderForm.regon().dirty())
                    ? 'error'
                    : ''
                "
              >
                <input
                  nz-input
                  placeholder="Numer REGON"
                  [formField]="serviceProviderForm.regon"
                  [nzStatus]="serviceProviderForm.regon().invalid() ? 'error' : ''"
                />
                <app-field-error
                  [control]="serviceProviderForm.regon()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </nz-card>

      <!-- NFZ -->
      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="medicine-box" nzTheme="outline" class="section-icon"> </span>

          <span> Dane NFZ </span>
        </div>
        <div nz-row [nzGutter]="[24, 0]">
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label> Oddział NFZ </nz-form-label>

              <nz-form-control
                [nzValidateStatus]="
                  serviceProviderForm.nhfBranchCode().invalid() &&
                  (serviceProviderForm.nhfBranchCode().touched() ||
                    submitted() ||
                    serviceProviderForm.nhfBranchCode().dirty())
                    ? 'error'
                    : ''
                "
              >
                <nz-select
                  nzPlaceHolder="Kod oddziału NFZ"
                  [formField]="serviceProviderForm.nhfBranchCode"
                  [nzStatus]="serviceProviderForm.nhfBranchCode().invalid() ? 'error' : ''"
                >
                  @for (item of nfzBranchCodes; track item.code) {
                    <nz-option [nzValue]="item.code" [nzLabel]="item.name"> </nz-option>
                  }
                </nz-select>
                <app-field-error
                  [control]="serviceProviderForm.nhfBranchCode()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="6">
            <nz-form-item>
              <nz-form-label> Kod świadczeniodawcy </nz-form-label>

              <nz-form-control
                [nzValidateStatus]="
                  serviceProviderForm.code().invalid() &&
                  (serviceProviderForm.code().touched() ||
                    submitted() ||
                    serviceProviderForm.code().dirty())
                    ? 'error'
                    : ''
                "
              >
                <input
                  nz-input
                  placeholder="Kod"
                  [formField]="serviceProviderForm.code"
                  [nzStatus]="serviceProviderForm.code().invalid() ? 'error' : ''"
                />
                <app-field-error
                  [control]="serviceProviderForm.code()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="6">
            <nz-form-item>
              <nz-form-label> Numer rejestrowy </nz-form-label>

              <nz-form-control
                [nzValidateStatus]="
                  serviceProviderForm.registryNumber().invalid() &&
                  (serviceProviderForm.registryNumber().touched() ||
                    submitted() ||
                    serviceProviderForm.registryNumber().dirty())
                    ? 'error'
                    : ''
                "
              >
                <input
                  nz-input
                  placeholder="Numer rejestru"
                  [formField]="serviceProviderForm.registryNumber"
                  [nzStatus]="serviceProviderForm.registryNumber().invalid() ? 'error' : ''"
                />
                <app-field-error
                  [control]="serviceProviderForm.registryNumber()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </nz-card>

      <!-- ADRES -->
      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="environment" nzTheme="outline" class="section-icon"> </span>

          <span> Adres </span>
        </div>

        <div nz-row [nzGutter]="[24, 0]">
          <div nz-col [nzXs]="24" [nzSm]="4">
            <nz-form-item>
              <nz-form-label> Kod pocztowy </nz-form-label>

              <nz-form-control
                [nzValidateStatus]="
                  serviceProviderForm.zip().invalid() &&
                  (serviceProviderForm.zip().touched() ||
                    submitted() ||
                    serviceProviderForm.zip().dirty())
                    ? 'error'
                    : ''
                "
              >
                <input
                  nz-input
                  placeholder="00-000"
                  [formField]="serviceProviderForm.zip"
                  [nzStatus]="serviceProviderForm.zip().invalid() ? 'error' : ''"
                />
                <app-field-error
                  [control]="serviceProviderForm.zip()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="8">
            <nz-form-item>
              <nz-form-label> Miejscowość </nz-form-label>

              <nz-form-control
                [nzValidateStatus]="
                  serviceProviderForm.place().invalid() &&
                  (serviceProviderForm.place().touched() ||
                    submitted() ||
                    serviceProviderForm.place().dirty())
                    ? 'error'
                    : ''
                "
              >
                <input
                  nz-input
                  placeholder="Miejscowość"
                  [formField]="serviceProviderForm.place"
                  [nzStatus]="serviceProviderForm.place().invalid() ? 'error' : ''"
                />
                <app-field-error
                  [control]="serviceProviderForm.place()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label> Ulica </nz-form-label>

              <nz-form-control
                [nzValidateStatus]="
                  serviceProviderForm.street().invalid() &&
                  (serviceProviderForm.street().touched() ||
                    submitted() ||
                    serviceProviderForm.street().dirty())
                    ? 'error'
                    : ''
                "
              >
                <input
                  nz-input
                  placeholder="Ulica"
                  [formField]="serviceProviderForm.street"
                  [nzStatus]="serviceProviderForm.street().invalid() ? 'error' : ''"
                />
                <app-field-error
                  [control]="serviceProviderForm.street()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </nz-card>

      <!-- KONTAKT -->
      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="phone" nzTheme="outline" class="section-icon"> </span>

          <span> Kontakt </span>
        </div>
        <div nz-row [nzGutter]="[24, 0]">
          <div nz-col [nzXs]="24" [nzSm]="8">
            <nz-form-item>
              <nz-form-label> Telefon </nz-form-label>

              <nz-form-control
                [nzValidateStatus]="
                  serviceProviderForm.phone().invalid() &&
                  (serviceProviderForm.phone().touched() ||
                    submitted() ||
                    serviceProviderForm.phone().dirty())
                    ? 'error'
                    : ''
                "
              >
                <input
                  nz-input
                  placeholder="Numer telefonu"
                  [formField]="serviceProviderForm.phone"
                  [nzStatus]="serviceProviderForm.phone().invalid() ? 'error' : ''"
                />
                <app-field-error
                  [control]="serviceProviderForm.phone()"
                  [submitted]="submitted()"
                ></app-field-error>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </nz-card>
    </form>

    <div class="button-footer-wrapper">
      <a nz-button nzType="default" routerLink="/service-providers">
        <span nz-icon nzType="arrow-left"></span>
        Wstecz
      </a>

      <button
        nz-button
        nzType="primary"
        (click)="submit()"
        [nzLoading]="isSubmitting()"
        [disabled]="isSubmitting() || (!serviceProviderForm().valid() && submitted())"
      >
        <span nz-icon nzType="save"></span>
        Zapisz zmiany
      </button>
    </div>
    @if (!this.serviceProviderForm().valid() && submitted()) {
      <span class="ant-form-item-explain-error form-error">Formularz zawiera błędy</span>
    }
  }
</div>
